import { CATEGORY_COLORS, CATEGORY_LABELS } from '../lib/labels';
import './primitives.css';

function CategoryChip({ category = 'unknown', size = 14, label = false, className = '' }) {
  const color = CATEGORY_COLORS[category] || CATEGORY_COLORS.unknown;
  return (
    <span
      className={`category-chip ${className}`.trim()}
      style={{ width: size, height: size, background: color }}
      aria-label={CATEGORY_LABELS[category] || category}
      title={label ? undefined : CATEGORY_LABELS[category] || category}
    />
  );
}

export default CategoryChip;
